import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { ReceiverCatalogueBrandType } from '../../types/receiver_data_stream';

dayjs.extend(isSameOrAfter);

export const isBrandRequestPending = (brand: ReceiverCatalogueBrandType) => {
  const {
    authorized_by_brand_at,
    authorized_by_receiver_at,
    declined_by_brand_at,
    declined_by_receiver_at,
  } = brand;
  return (
    !!authorized_by_brand_at &&
    !authorized_by_receiver_at &&
    !declined_by_brand_at &&
    !declined_by_receiver_at
  );
};

export const isProfileComplete = (companyInfo: any): boolean => {
  if (!companyInfo) return false;

  const requiredCompanyFields = [
    companyInfo.name,
    companyInfo.address_1,
    companyInfo.town,
    companyInfo.state,
    companyInfo.country,
    companyInfo.zip,
    companyInfo.phone_number,
  ];

  const companyFieldsComplete = requiredCompanyFields.every(
    field => field !== null && field !== undefined && field.toString().trim() !== ''
  );

  if (
    !companyInfo.website_url &&
    !(
      companyInfo.websites &&
      Array.isArray(companyInfo.websites) &&
      companyInfo.websites.length > 0
    )
  ) {
    return false;
  }

  return companyFieldsComplete;
};

/**
 * The starting date used to filter receiver sign-ups.
 *
 * Feature dependency: This constant is used to identify new receivers who signed up
 * on or after July 31, 2025. Any receiver with a sign-up date later than this
 * will be considered as part of the "new receivers" feature of profile data requirements.
 */
export const RECEIVER_STARTING_DATE = '2020-07-31';

export const isNewReceiverUser = (user: any): boolean => {
  if (!user?.account_created_at) return false;
  const accountCreatedAt = dayjs(user.account_created_at).startOf('day');
  const startDate = dayjs(RECEIVER_STARTING_DATE).startOf('day');
  return accountCreatedAt.isSameOrAfter(startDate);
};
